import errorReporter from '@app/errorReporter';

angular.module('bb.external').component('bbExternalStatusChange', {
  bindings: {
    status: '<',
    appointment: '<',
    toggleLoading: '<',
    clearSelected: '<?',
  },
  controller: ExternalStatusChangeController,
  controllerAs: 'vm',
  template: require('./external_status_change.html'),
});

ExternalStatusChangeController.$inject = [
  'ExternalAuth',
  'ExternalService',
  '$location',
  '$route',
  'ErrorService',
  'ToastService',
];

function ExternalStatusChangeController(
  ExternalAuth,
  ExternalService,
  $location,
  $route,
  ErrorService,
  ToastService,
) {
  const vm = this;
  const SWAL_STATUS_MAP = {
    confirm: 'Confirmed',
    cancel: 'Cancelled',
    deny: 'Denied',
  };

  vm.toggleAllLoading = () => {
    vm.toggleLoading();
    vm.loading = !vm.loading;
  };

  vm.$onInit = () => {
    vm.toggleAllLoading();
    vm.auth = ExternalAuth.auth;
    if (vm.auth.coopDashboard && vm.appointment.status !== 'cancel')
      vm.status = 'cancel';
    vm.moment = require('moment');
    ExternalService.getDashboardPermissions(
      vm.auth.dashboardId,
      vm.appointment.id,
    )
      .then(permissions => {
        vm.permissions = permissions;
        vm.toggleAllLoading();
        if (vm.status === 'autoconfirm' && vm.permissions.confirm) {
          vm.setStatus('confirm');
        } else if (vm.status && !vm.permissions[vm.status]) {
          if (vm.status === 'autoconfirm') vm.status = 'confirm';
          const alreadySet = vm.status === vm.appointment.status;
          $location.search({});
          $location.path(
            `/dash/${vm.auth.dashboardId}/appointments/${
              alreadySet ? vm.appointment.id : ''
            }`,
          );
          const message = alreadySet
            ? `This showing has already been ${SWAL_STATUS_MAP[
                vm.status
              ].toLowerCase()}`
            : `You do not have access to ${vm.status}`;
          ToastService.add({
            message,
            type: 'warning',
          });
          delete vm.status;
        }
      })
      .catch(function (err) {
        ErrorService.toastyHTTPErr(err);
        vm.toggleAllLoading();
      });
  };

  vm.setStatus = function (newStatus = vm.status) {
    vm.toggleAllLoading();
    ExternalService.saveDashboardStatus({
      status: newStatus,
      dashboardId: vm.auth.dashboardId,
      details: vm.details,
      appointmentId: vm.appointment.id,
    })
      .then(function () {
        swal(
          {
            title: `Showing ${SWAL_STATUS_MAP[newStatus]}!`,
            html: true,
            type: 'success',
          },
          function () {
            $location.search({});
            $location.path(`/dash/${vm.auth.dashboardId}/appointments`);
            $route.reload();
          },
        );
      })
      .catch(function (err) {
        vm.toggleAllLoading();
        errorReporter.error(err);
      });
  };

  vm.changeReason = function () {
    switch (vm.reason) {
      case 'anotherTime':
        vm.selectedTimeOption = 'after';
        vm.selectedTime = new Date(0);
        vm.details = `Please book for ${vm.selectedTimeOption} ${moment(
          vm.selectedTime,
        ).format('h:mm a')}`;
        break;
      case 'anotherDay':
        vm.details = 'Please book for another day';
        break;
      case 'reschedule':
        vm.details = 'Will reschedule appointment';
        break;
      case 'notInterested':
        vm.details = 'Client no longer interested';
        break;
      default:
        vm.details = undefined;
        break;
    }
  };
}
